/**
 *
 * NotesLanding
 *
 */

import { mapState, mapGetters, mapMutations } from 'vuex';
//import _ from 'lodash';
//import $ from 'jquery';

export default {
  name: 'NotesLandingCourse',

  computed: {
    ...mapState('Notes', {
      ms_isGeneratingPdf: 'isGeneratingPdf',
    }),

    ...mapGetters('Notes/NotesLanding', {
      mg_lstNotesGroupActive: 'lstNotesGroupActive',
    }),
  },

  methods: {
    ...mapMutations('Notes/NotesLanding', {
      mm_SET_COURSE_IDX: 'SET_COURSE_IDX',
    }),

    selectCourse(courseIdx) {
      this.mm_SET_COURSE_IDX(courseIdx);
      this.$emit('select-course');
    },

    setScrollNote() {
      if (this.$refs.courses) {
        for (let i = 0; i < this.$refs.courses.length; i++) {
          let { top } = this.$refs.courses[i].getBoundingClientRect();
          if (top > 80 && top < 320) {
            let courses = this.$refs.courses[i];
            const courseIdx = parseInt(courses.getAttribute('data-courseIdx'));
            this.mm_SET_COURSE_IDX(courseIdx);
            break;
          }
        }
      }
    },
  },

  mounted() {
    window.addEventListener('scroll', this.setScrollNote, true);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.setScrollNote, true);
  },
};
